import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const LoanStatusApi = createAsyncThunk(
  'LoanStatusApi',
  async (loanStatusPayload, { dispatch }) => {
    dispatch({ type: 'LoanStatusApi/pending', payload: {} });
    const {
      appId,
      appVersion,
      customerRefNum,
      loanAccountNum,
      uin,
      tpLeadId,
      customerId,
      Authorization,
    } = loanStatusPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/loanstatus',
      payload: {
        customerRefNum,
        loanAccountNum,
        uin,
        tpLeadId,
        appId,
        appVersion,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const loanStatusRes = res;
        dispatch({
          type: 'LoanStatusApi/fulfilled',
          payload: loanStatusRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'LoanStatusApi/rejected', payload: err });
      },
    });
  }
);

export const LoanStatusApi_extrareducer = {
  [LoanStatusApi.pending]: (state, action) => {
    state.loanStatusApiState.isLoading = true;
  },
  [LoanStatusApi.fulfilled]: (state, action) => {
    state.loanStatusApiState.isLoading = false;
    state.loanStatusApiState.isSuccess = true;
    state.loanStatusApiState.isError = false;
    state.loanStatusApiState.response = action.payload;
  },
  [LoanStatusApi.rejected]: (state, action) => {
    state.loanStatusApiState.isLoading = false;
    state.loanStatusApiState.isSuccess = false;
    state.loanStatusApiState.isError = true;
    state.loanStatusApiState.response = action.payload;
  },
};
